import { Component, Input, OnInit } from '@angular/core';
import { MatProgressBar } from '@angular/material/progress-bar';

@Component({
    selector: 'uw-progress-widget',
    templateUrl: './progress-widget.component.html',
    styleUrls: ['./progress-widget.component.scss'],
    imports: [MatProgressBar]
})
export class ProgressWidgetComponent implements OnInit {

  @Input()
  title: string ='';

  @Input()
  progress: string = '0';

  @Input()
  unit: string = '%';

  constructor() { }

  ngOnInit(): void {
  }

}
